import { Link } from 'react-router-dom';
import styled from 'styled-components';

export const ListSection = styled.div`
	background: #FFFFFF;
	box-shadow: 0px 2px 8px rgba(133, 133, 133, 0.26);
	border-radius: 14px;
	padding: calc(100vw*(14/375)) calc(100vw*(16/375));
	margin-bottom : calc(100vw*(11.5/375));
`;
export const SingleSection = styled.div`
	background: #FFFFFF;
	box-shadow: 0px 2px 8px rgba(133, 133, 133, 0.26);
	border-radius: 14px;
	padding: 0 calc(100vw*(17/375));
	margin-bottom : calc(100vw*(11.5/375));
`;
export const ListHeader = styled(Link)`
	border-bottom: 1px solid #E5E5E5;
	padding-bottom: calc(100vw*(13.5/375));
	margin-bottom: calc(100vw*(4/375));
    display: flex;
    align-items: center;
    justify-content: space-between
`;
export const HeaderLeft = styled.div`
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	display: inline-block;
	width: 100%;
	    padding-right: 5px;
`;
export const TitleTxt = styled.span`
	font-weight: 500;
	font-size: calc(100vw*(16/375));
	line-height: calc(100vw*(23/375));
`;
export const ArrowIconWrapper = styled.div`
	display:inline-block;
	width: calc(100vw*(8/375));
	height: calc(100vw*(14/375));
`;
export const HeaderRight = styled.div`
	width: calc(100vw*(8/375));
	height: calc(100vw*(14/375));
`;
export const ListBody = styled.div``;